module.exports = __webpack_public_path__ + "media/npc_dota_hero_dark_seer.2b404bc0.webm";